export const parseHtml = (text) => text == null ? '' : text.replace(/(<[^>]+>)|(&nbsp;)/gi, '');
